import { FC } from 'react';
import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { GraphQLError } from 'graphql';

import IconTile, { IconTileProps } from 'common/components/IconTile/IconTile';
import { mapSharedPropertiesToFields } from 'common/getters';
import { SitecoreFieldTypes } from 'common/types/sitecore';
import { ComponentProps } from 'lib/component-props';

export type Fields<Name extends string, ResultType> = {
  fields: {
    data: {
      item: {
        [name in Name]: {
          results: ResultType[];
        };
      };
    };
    errors: GraphQLError[];
  };
};

export type Tile = {
  id: string;
  iconName: Field<string>;
  title: Field<string>;
  subtitle: Field<string>;
  body: Field<string>;
  linkPath: Field<string>;
  linkTitle: Field<string>;
};

export type TextBannerProps = ComponentProps & Fields<'tiles', SitecoreFieldTypes>;

const IconTiles: FC<TextBannerProps> = ({ fields }) => {
  if (fields?.errors?.length) {
    return <div>{fields.errors[0].message}</div>;
  }
  const {
    data: {
      item: {
        tiles: { results },
      },
    },
  } = fields;
  const tileItems = results.map((result) => {
    return mapSharedPropertiesToFields<Tile>(result);
  }) as Tile[];
  return (
    <div className="flex flex-col flex-wrap justify-center max-lg:container-fluid lg:container lg:flex-row lg:gap-x-6 lg:gap-y-20 xl:gap-x-10">
      {tileItems.map(({ id, iconName, title, subtitle, body, linkPath, linkTitle }) => (
        <IconTile
          key={id}
          className="container flex-1 even:bg-gray-50 lg:m-0 lg:min-w-80 lg:max-w-96 lg:even:bg-white"
          iconName={iconName.value.trim() as IconTileProps['iconName']}
          title={title.value}
          subtitle={subtitle.value}
          htmlContent={body.value}
          link={{
            text: linkTitle.value,
            title: linkTitle.value,
            href: linkPath.value || '/',
            target: '_self',
          }}
        />
      ))}
    </div>
  );
};

export default withDatasourceCheck()<TextBannerProps>(IconTiles);
